module.exports = __webpack_public_path__ + "static/img/indicador-sentimento.ec98aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indicador-sentimento.png
// module id = gsxB
// module chunks = 1